import { DesignProp } from "../PropCategories";

export const objectFit = {
  prop: "style-attribute",
  name: "Object Fit",
  nameI18n: "builder_ui.prop_type.styles.object_fit",
  category: [DesignProp],
  type: "select",
  defaultValue: "cover",
  options: [
    {
      label: "Cover",
      labelI18n: "builder_ui.prop_type.styles.object_fit_types.cover",
      value: "cover",
    },
    {
      label: "Contain",
      labelI18n: "builder_ui.prop_type.styles.object_fit_types.contain",
      value: "contain",
    },
    {
      label: "Fill",
      labelI18n: "builder_ui.prop_type.styles.object_fit_types.fill",
      value: "fill",
    },
    {
      label: "None",
      labelI18n: "builder_ui.prop_type.styles.object_fit_types.none",
      value: "none",
    },
  ],
} as const;
